import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/Input'
import Typography from '@material-ui/core/Typography'
import Drug from './Drug'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'
import { withStyles } from '@material-ui/core/styles'
import { getCancerTreatments, createPatientTreatment } from '../../api'

const styles = theme => ({
  root: {},
  flex: {
    display: 'flex',
    marginLeft: 30,
    marginBottom: 12
  },
  inputWrapper: {
    margin: '0 30px',
    marginTop: 10
  },
  textInput: {
    width: '100%',
    marginTop: 10,
  },
  topInputs: {
    width: 150,
    marginRight: 10
  },
  error: {
    margin: '15px 30px',
    color: theme.palette.primary.error
  }
})

const DOSES = [{id: 1, name: 5}, {id: 2, name: 10}]
const UNITS = ['mg', 'mg/m2', 'g', 'ACU', 'mg/kg', 'mcg', 'units', 'mcg/kg', 'other']
const FREQUENCIES = ['times daily', 'times per week', 'week interval', 'day interval', 'month interval', 'other']
const EMPTY_DRUG = {drug_id: '', frequency_value: '', frequency_units: '', dosage_value: '', dosage_units: ''}

const initialDrugs = () => {
  return {
    1: Object.assign({}, EMPTY_DRUG),
    2: Object.assign({}, EMPTY_DRUG),
    3: Object.assign({}, EMPTY_DRUG),
    4: Object.assign({}, EMPTY_DRUG),
    5: Object.assign({}, EMPTY_DRUG),
  }
}

const INITIAL_STATE = {
  error: false,
  start_date: null,
  cycles: null,
  treatments: [],
  drugs: Object.assign({}, initialDrugs()),
  notes: ''
}

class TreatmentModal extends Component {
  constructor (props) {
    super(props)

    this.state = Object.assign({}, INITIAL_STATE)
  }

  componentDidMount () {
    getCancerTreatments().then(treatments => this.setState({treatments: treatments.sort((a,b) => a.name <= b.name ? -1 : 1)}))
  }

  onClose = () => {
    const newState = Object.assign({},
      INITIAL_STATE,
      {
        treatments: this.state.treatments,
        drugs: Object.assign({}, initialDrugs())
      })
    this.setState(newState, this.props.onClose)
  }

  validate = data => {
    const { drugs, start_date } = data

    if (!start_date) {
      return false
    }

    return [1,2,3,4,5].some(idx => {
      return drugs[idx].drug_id && drugs[idx].dosage_units && drugs[idx].dosage_value && drugs[idx].frequency_units && drugs[idx].frequency_value
    })
  }

  save = () => {
    const { treatments, error, ...treatmentData } = this.state
    if (!this.validate(treatmentData)) {
      this.setState({error: true})
      return;
    }
    const data = Object.assign({}, treatmentData, { drugs: Object.assign({}, treatmentData.drugs)});
    [1,2,3,4,5].forEach(idx => {
      if (!data.drugs[idx].drug_id) {
        delete data.drugs[idx]
      } else {
        // strip blank keys
        Object.keys(data.drugs[idx]).forEach(key => {
          if (data.drugs[idx][key] === '') {
            delete data.drugs[idx][key]
          }
        })
      }
    })
    data.drugs = Object.values(data.drugs)
    this.props.onSave(data).then(this.onClose).catch(error => this.setState({ error: true }))
  }

  updateDrug = (drugNumber, field, value) => {
    let drugs = Object.assign({}, this.state.drugs)
    if (!drugs[drugNumber]) drugs[drugNumber] = {}
    drugs[drugNumber] = Object.assign(drugs[drugNumber], {[field]: value})
    this.setState({drugs: drugs})
  }

  renderError () {
    if (!this.state.error) return
    const { classes } = this.props
    let message
    switch (this.state.start_date) {
      case null:
        message = 'a start date.'
        break;
      default:
        message = 'at least one drug with all fields filled in.'
    }
    return (
      <Typography className={classes.error}>
        Invalid entry: please enter {message}
      </Typography>
    )
  }

  render () {
    if (!this.props.open) return null;
    const { classes } = this.props
    return (
      <Dialog maxWidth={false} open={this.props.open} onClose={this.onClose} className={classes.root}>
        <DialogTitle>Add New Treatment</DialogTitle>
        <DialogContent>
          <div className={classes.flex}>
            <div className={classes.topInputs}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  label="Start Date"
                  placeholder="Start Date"
                  value={this.state.start_date}
                  onChange={date => this.setState({start_date: date})}
                />
              </MuiPickersUtilsProvider>
              </div>
              <FormControl className={classes.topInputs}>
                <InputLabel>Number of Cycles</InputLabel>
                <TextField
                  className={classes.textInput}
                  label="Number of Cycles"
                  placeholder="Number of Cycles"
                  value={this.state.cycles}
                  onChange={e => this.setState({cycles: e.currentTarget.value})}
                />
              </FormControl>
          </div>
          {
            [1,2,3,4,5].map(idx => <Drug number={idx} treatments={this.state.treatments} doses={DOSES} units={UNITS} frequencies={FREQUENCIES} values={this.state.drugs[idx] || {}} onChange={this.updateDrug}/>)
          }
          <div className={classes.inputWrapper}>
            <TextField
              className={classes.textInput}
              label="Treatment Notes"
              placeholder="Treatment Notes"
              value={this.state.notes}
              onChange={e => this.setState({notes: e.currentTarget.value})}
            />
          </div>
          {this.renderError()}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={this.save}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(TreatmentModal)



// WEBPACK FOOTER //
// ./src/components/TreatmentModal/TreatmentModal.js